import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_SENSITIVE_SUMMARY_CARD_DATA } from "../../DataTagConstants";
import RegulatedScatterChart from "./RegulatedScatterChart";
import "./DataEstateSensitiveCard.scss";


const CLASSIFICATION_COLORS = {
  PCI: "#e74c3c",
  PII: "#3498db",
  "PHI/HIPAA": "#16a085",
  GDPR: "#9b59b6",
  Confidential: "#27ae60",
  Financial: "#f1c40f",
};


export default function DataEstateRegulatedCard({ expanded = false }) {
  const dispatch = useDispatch();
  const [activeFilter, setActiveFilter] = useState(null);

  const dataSourceId = useSelector(
    (state) => state.dataTagReducer.selectedDataSource?.id
  );

  const sensitiveCardData = useSelector(
    (state) => state.dataTagReducer.sensitiveCardData
  );

  const classificationStats =
    sensitiveCardData?.fileClassificationStatus || [];


  useEffect(() => {
    if (dataSourceId) {
      dispatch({
        type: FETCH_SENSITIVE_SUMMARY_CARD_DATA,
        payload: dataSourceId,
      });
    }
  }, [dataSourceId, dispatch]);


  const filters = useMemo(() => {
    const set = new Set();
    classificationStats.forEach((item) => {
      item["FileClassificationStats.classificationCombination"]
        .split(",")
        .forEach((c) => set.add(c.trim()));
    });
    return Array.from(set);
  }, [classificationStats]);

  const toggleFilter = (type) => {
    setActiveFilter((prev) => (prev === type ? null : type));
  };

  if (!classificationStats.length) {
    return <div className="no-data">No data available</div>;
  }


  return (
    <div
      className={`sensitivity-summary-box ${
        expanded ? "expanded" : "collapsed"
      }`}
    >
      {expanded && <div className="ss-header">Regulated</div>}

      <div className="ss-filters">
        {filters.map((type) => {
          const active = activeFilter === type;
          return (
            <div
              key={type}
              className={`ss-filter ${active ? "active" : ""}`}
              style={{ "--filter-color": CLASSIFICATION_COLORS[type] }}
              onClick={() => toggleFilter(type)}
            >
              {type}
            </div>
          );
        })}
      </div>

      <RegulatedScatterChart
        data={classificationStats}
        expanded={expanded}
        activeFilter={activeFilter}
      />
    </div>
  );
}
